module.exports = __webpack_public_path__ + "img/scene3--after_2.svg";